<template>
  <div class="wrap REFERRAL">
    <div class="header">
      <header>
        <NavBar
          title="REFERRAL"
          left-arrow
          @click-left="$router.go(-1)"
          class="no_bg"
        />
      </header>
    </div>
    <div class="main">






      <!-- 商品列表页 -->
      <div class="listTitle">Other Recommendation</div>
      <button @click="pay">测试paypal</button>
    </div>
    <Cell is-link @click="showPopup">展示弹出层</Cell>
    <Popup closeable v-model="show"   position="bottom"
  :style="{ height: '30%' }">
      内容
    </Popup>
    <!-- 弹窗 -->
    <!-- <van-dialog v-model="show" title="Get Email Address" show-cancel-button>
        <div>
          <div>
            <Field
              v-model="username"
              placeholder="Please fill in the collection email"
              clearable
              :error-message="usernamemsg"
            />
          </div>
          <div style="padding-bottom: 10px;">
            Your personal data will not be shared with any third-party companies. For more details,please check the   
          </div>
        </div>
      </van-dialog> -->

    <!-- <PayPal
      amount="10.00" // 付款的钱数
      currency="USD" // 货币种类，默认为美元
      :client="credentials" // client_id认证信息
      env="sandbox" // 指定环境，默认为线上，也就是production
      :button-style="buttonStyle" // 自定义按钮样式
      @payment-authorized="paymentAuthorized"
      @payment-completed="paymentCompleted"
      @payment-cancelled="paymentCancelled"
      ></PayPal> -->
    <!-- paypay 支付start -->
    <PayPal
      amount="0.01"
      currency="USD"
      :client="credentials"
      env="sandbox"
      :button-style="buttonStyle"
      @payment-authorized="paymentAuthorized"
      @payment-completed="paymentCompleted"
      @payment-cancelled="paymentCancelled"
    ></PayPal>
    <!-- paypay 支付end -->
  </div>
</template>
<script>
import PayPal from "vue-paypal-checkout";


export default {
  data() {
    return {


      show: false,
      amount: 1.1,
      cardNumberPlaceholder: "请输入你的信用卡号",
      cardCVVPlaceholder: "请输入信用卡号背面3位号码",
      cardDatePlaceholder: "请输入信用卡有效期",

      client: null,
      hostedFields: null,
      threeDSecure: null,
      paypal: null,

      clientErr: null,
      clientInstance: null,
      hostedFieldsInstance: null,

      // paypay 支付start
      credentials: {
        // sandbox: 'Ad1voWYq3VL8J4jy6zWARKwz4tjbuDl_TFBa3WQqy_DwAFWd7hkU4i99jijGqaoqU3E-ODqXDayVnOdl',   //系统的
        sandbox:
          "AYmK2dN-JT7bpEaImW9Vg_tXI5EInLr1bog2ZLzrmiFoEmZgdLL3eMBbXS1VgKBMmI_Ua2U0g7yrUzxP", //
        production: ""
      },
      buttonStyle: {
        label: "pay",
        size: "small",
        shape: "rect",
        color: "blue"
      }
      // paypay 支付end
    };
  },
  mounted() {
    this.client = require("/src/lib/client.min");
    this.hostedFields = require("@/lib/hosted-fields.min.js");
    this.threeDSecure = require('@/lib/three-d-secure.min.js');
    this.paypal = require('@/lib/paypal.min.js');
    console.log(123, this.paypal);
    console.log(124, this.client);
    this.client.create(
      {
        authorization:
        // "AYmK2dN-JT7bpEaImW9Vg_tXI5EInLr1bog2ZLzrmiFoEmZgdLL3eMBbXS1VgKBMmI_Ua2U0g7yrUzxP"
          "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"
      },
      (clientErr, clientInstance) => {
        // console.log("clientErr:", clientErr)
        // console.log("clientInstance:", clientInstance)

        this.clientErr = clientErr;
        this.clientInstance = clientInstance;
        if (this.clientErr) {
          console.error("Error creating client:", clientErr);
          return;
        }
        this.showView();
        console.warn("braintree init scuess!");
      }
    );
  },
  components: {
    PayPal
  },
  computed: {
    // usernamemsg () {
    //     if (this.username === '') {
    //         return ''
    //     } else if (!/^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/.test(this.username)) {
    //         return '邮箱码格式错误'
    //     } else {
    //         return ''
    //     }
    // },
  },
  methods: {

    showPopup() {
      this.show = true;
    },
    pay() {
      console.log("payPaypal");
      console.log(" this.client:", this.client);
      this.paypal.create(
        {
          client: this.clientInstance
        },
        function(paypalErr, paypalInstance) {
          if (paypalErr) {
            console.error("Error creating PayPal:", paypalErr);
            return;
          }

          paypalInstance.tokenize(
            {
              flow: "checkout",
              amount: this.amount,
              currency: "USD"
            },
            function(tokenizeErr, payload) {
              if (tokenizeErr) {
                if (tokenizeErr.type !== "CUSTOMER") {
                  console.log("Error tokenizing:", tokenizeErr);
                }
                return;
              }
              console.log(
                "payPaypal ->payload:支付成功 去服务端验证",
                payload.nonce
              );
            }
          );
        }.bind(this)
      );
    },
    showView() {
      this.hostedFields.create(
        {
          client: this.clientInstance,
          fields: {
            number: {
              selector: "#cc-number",
              placeholder: this.cardNumberPlaceholder
            },
            cvv: {
              selector: "#cc-cvv",
              placeholder: this.cardCVVPlaceholder
            },
            expirationDate: {
              selector: "#cc-expiration-date",
              placeholder: this.cardDatePlaceholder
            }
          }
        },
        function(err, hostedFieldsInstance) {
          if (err) {
            console.error("this.hostedFields.create:", err);
            return;
          }
          this.hostedFieldsInstance = hostedFieldsInstance;
        }.bind(this)
      );
    },

    abc() {
      this.show = true;
      this.$toast({
        message: `<div style="height:22px;padding:10px 0;display:flex;justify-content: center;align-items: center;">
          <div class="van-icon van-icon-passed" style="font-size:16px;margin-right:5px"></div>
          <div>The coupon code has been sent to your email.</div></div>`,
        type: "html"
      });
      // this.$toast.success('The coupon code has been sent to your email.');
    },
    getUserInfo(event) {
      console.log(event.detail);
    },

    onClose() {
      // this.setData({ show: false });
      this.show = false;
    },
    changelogin() {},
    usernamemsg() {},
    passwordErr() {},

    // paypay 支付start
    paymentAuthorized(data) {
      // 授权完成的回调，可以拿到订单id
      console.log(data);
    },

    paymentCompleted(data) {
      // 用户支付完成的回调，可以拿到订单id
      console.log(data);
    },

    paymentCancelled(data) {
      // 用户取消交易的回调
      console.log(data);
    }
    // paypay 支付end
  }
};
</script>
<style lang="less" scoped>
.REFERRAL {
  .listTitle {
    font-size: 20px;
    font-weight: bold;
    padding: 20px 0;
    color: #4181ff;
  }
  .listBox {
    overflow: hidden;
    .listBoxTitle {
      font-size: 15px;
      font-weight: bold;
      padding: 0 0 10px 10px;
      text-align: left;
    }
    .listScroll {
      width: 100%;
      display: flex;
      overflow: scroll;
      margin-bottom: 20px;
    }
    .listItem {
      text-align: left;
      margin-left: 10px;
      width: 144px;
      .listText {
        padding-left: 5px;
      }
      img {
        width: 100%;
      }
    }
  }
  .title {
    font-size: 15px;
    font-weight: 500;
    color: #333;
    word-break: normal;
  }
}
</style>
